import React from "react";
import { BlogPostResource } from "./types";

interface Props {
  post: BlogPostResource;
}

const encodedShareUrl = (path: string) => {
  const origin = window.location.origin;
  return encodeURIComponent(`${origin}${path}`);
};

const ShareLinks = ({ post }: Props) => {
  const url = encodedShareUrl(post.blog_post_path);
  const title = encodeURIComponent(post.title);
  const media = post.hero_image_url
    ? `&media=${encodeURIComponent(post.hero_image_url)}`
    : "";

  const links = [
    {
      label: "Facebook",
      url: `https://www.facebook.com/sharer/sharer.php?u=${url}`
    },
    {
      label: "Twitter",
      url: `https://twitter.com/intent/tweet?url=${url}&text=${title}`
    },
    {
      label: "LinkedIn",
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${url}`
    },
    {
      label: "Reddit",
      url: `https://www.reddit.com/submit?url=${url}&title=${title}`
    },
    {
      label: "Pinterest",
      url: `https://pinterest.com/pin/create/button/?url=${url}&description=${title}${media}`
    }
  ];

  return (
    <aside className="blog-post-page__share" aria-label="Share this post">
      <span>Share</span>
      <div>
        {links.map(link => (
          <a
            href={link.url}
            key={link.label}
            rel="noopener noreferrer"
            target="_blank"
          >
            {link.label}
          </a>
        ))}
      </div>
    </aside>
  );
};

export default ShareLinks;
